export default __webpack_public_path__ + "static/media/bitmap@4x.589e5905.png";